<template>
    <div class="health">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/protocol'})">返回</i>
      <div class="health_wrap">
        <div class="health_box">
          <p class="title">您是否患有以下疾病</p>
          <p class="tips">您填写的结果会直接影响您最终的风险数值，请您准确填写</p>
          <van-form>
            <van-field
              readonly
              clickable
              name="datetimePicker"
              right-icon="arrow-down"
              :value="form.birthday"
              label="出生年月日"
              placeholder="请输入出生年月日"
              @click="showPicker = true"
            />
            <van-grid :column-num="3">
              <van-grid-item>疾病名称</van-grid-item>
              <van-grid-item>正患</van-grid-item>
              <van-grid-item>曾患</van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>冠心病</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.coronary_heart_disease">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.coronary_heart_disease">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>心肌梗塞</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.myocardial_infarction">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.myocardial_infarction">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>心绞痛</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.angina">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.angina">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>心脏支架</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.heart_stent">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.heart_stent">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>高血压</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.hypertension">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.hypertension">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
            <van-grid :column-num="3">
              <van-grid-item>动脉粥样硬化</van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.atherosclerosis">
                  <van-checkbox shape="square" name="2" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
              <van-grid-item>
                <van-checkbox-group v-model="form.atherosclerosis">
                  <van-checkbox shape="square" name="3" @click="watchBirth"></van-checkbox>
                </van-checkbox-group>
              </van-grid-item>
            </van-grid>
          </van-form>
        </div>
        <van-checkbox class="notHave" v-model="notHave" @click="isNotHave">未患过上述疾病</van-checkbox>
        <div class="submitBtn" @click="submit">查看报告</div>
      </div>

      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm"
          @cancel="showPicker = false"
          :formatter="formatter"
        />
      </van-popup>
    </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  name: 'health',
  data () {
    return {
      minDate: new Date(1928, 12, 1),
      maxDate: new Date(),
      showPicker: false,
      notHave: false,
      form: {
        birthday: '',
        coronary_heart_disease: [],
        myocardial_infarction: [],
        angina: [],
        heart_stent: [],
        hypertension: [],
        atherosclerosis: []
      }
    }
  },
  methods: {
    isNotHave () {
      if (this.form.birthday === '') {
        Dialog.alert({
          title: '提示',
          message: '请填写年龄'
        }).then(() => {
          // on close
        })
      }
      this.form.coronary_heart_disease = []
      this.form.myocardial_infarction = []
      this.form.angina = []
      this.form.heart_stent = []
      this.form.hypertension = []
      this.form.atherosclerosis = []
    },
    watchBirth () {
      if (this.form.birthday === '') {
        Dialog.alert({
          title: '提示',
          message: '请填写年龄'
        }).then(() => {
          // on close
        })
      }
      this.notHave = false
    },
    submit () {
      if (this.form.birthday === '') {
        Dialog.alert({
          title: '提示',
          message: '请填写年龄'
        })
      } else if (this.form.coronary_heart_disease.length === 0 &&
        this.form.myocardial_infarction.length === 0 &&
        this.form.angina.length === 0 &&
        this.form.heart_stent.length === 0 &&
        this.form.hypertension.length === 0 &&
        this.form.atherosclerosis.length === 0 && this.notHave === false) {
        Dialog.alert({
          title: '提示',
          message: '请填写患病情况'
        })
      } else {
        Dialog.alert({
          title: '提示',
          message: '请确保信息无误，避免影响风险数值',
          closeOnClickOverlay: true,
          showCancelButton:true
        }).then(() => {
          // on close
          let birthday = this.form.birthday
          if (this.notHave) {
            delete this.form.birthday
            for (let i in this.form) {
              this.form[i].push(1)
            }
          }
          let postData = new FormData()
          let data = {
            birthday: birthday,
            coronary_heart_disease: this.form.coronary_heart_disease[0] || 1,
            myocardial_infarction: this.form.myocardial_infarction[0] || 1,
            angina: this.form.angina[0] || 1,
            heart_stent: this.form.heart_stent[0] || 1,
            hypertension: this.form.hypertension[0] || 1,
            atherosclerosis: this.form.atherosclerosis[0] || 1
          }
          postData.set('birthday', data.birthday)
          postData.set('coronary_heart_disease', data.coronary_heart_disease)
          postData.set('myocardial_infarction', data.myocardial_infarction)
          postData.set('angina', data.angina)
          postData.set('heart_stent', data.heart_stent)
          postData.set('hypertension', data.hypertension)
          postData.set('atherosclerosis', data.atherosclerosis)

          this.util.post(this.api.add_info, postData, (success) => {
            this.$router.push('/results')
          })
        })
      }
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    onConfirm (val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      this.form.birthday = `${year}-${month}-${day}`
      this.showPicker = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .health {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .health_wrap {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .health_box {
        padding: pxToRem(80px);
        background: #fff;
        border-radius: pxToRem(20px);

        .title {
          font-size: pxToRem(36px);
          font-weight: bold;
          color: #2A6BAE;
          text-align: center;
          margin-bottom: pxToRem(53px);
        }

        .van-cell {
          background: #C4E3FE;
          border:1px solid #221815;
          opacity: 0.47;
          border-radius: pxToRem(10px);
          font-size: pxToRem(20px);
          color: #000;
          margin: pxToRem(45px) 0;
        }
        .van-grid {
          font-size: pxToRem(20px);
        }
      }

      .notHave {
        width: pxToRem(300px);
        margin: pxToRem(56px) auto 0;
        text-align: center;

        .van-checkbox__label {
          font-weight: bold;
        }
      }

      .submitBtn {
        width: pxToRem(350px);
        height: pxToRem(70px);
        line-height: pxToRem(70px);
        background: url('../../assets/images/ceramide/healthbtn.png') no-repeat center;
        background-size: 100% 100%;
        font-size: pxToRem(28px);
        color: #fff;
        text-align: center;
        letter-spacing: pxToRem(5px);
        margin: pxToRem(32px) auto 0;
      }
    }
  }
</style>
<style lang="scss">
  .health {
    .van-field__label {
      color: #000;
    }

    .van-field__control {

      &::-webkit-input-placeholder {
        color: #000;
      }

      &::-moz-placeholder {
        color: #000;
      }

      &:-moz-placeholder {
        color: #000;
      }

      &:-ms-input-placeholder {
        color: #000;
      }
    }
    .van-grid {
      text-align: center;
      flex-wrap: nowrap;
    }
    .van-grid:nth-of-type(odd) .van-grid-item__content {
      background: #fff;
    }
    .van-grid:nth-of-type(even) .van-grid-item__content {
      background: #E3F2FF;
    }
    .van-grid:nth-of-type(2) .van-grid-item__content {
      background: #C4E3FE;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/health.vue